import * as React from 'react';
import icons from './icons';
import styled, { useTheme } from 'styled-components';
const Wrapper = styled.span `
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
export const Icon = ({ className, name: nameFromProps, color, size = 'm', }) => {
    const theme = useTheme();
    const sizeToPx = (size) => {
        const sizeMapping = {
            xs: 8,
            s: 12,
            m: 16,
            l: 24,
            xl: 40,
            xxl: 110,
        };
        return size in sizeMapping
            ? sizeMapping[size]
            : 16;
    };
    const getName = (nameFromProps) => {
        switch (nameFromProps) {
            case 'remove-smarttag':
                return 'close';
            case 'arrow-down-small':
            case 'chevron':
                return 'arrow-down';
            case 'arrow':
                return 'arrow-right';
            default:
                return nameFromProps;
        }
    };
    const name = getName(nameFromProps);
    const iconSize = typeof size === 'string' ? sizeToPx(size) : size;
    const iconColor = color ? color : theme.textColor;
    return (React.createElement(Wrapper, { className: `icon ${className}` }, name in icons
        ? icons[name](iconSize, iconColor)
        : null));
};
export default Icon;
export { default as icons } from './icons';
